import React, { Component } from "react";
import { CircularProgress } from "@mui/material";

var self;

export default class BusyLoader extends Component {
  state = {
    busyIcon: false,
    color: "#4aa5dc",
    width: "50px",
    height: "50px",
  };

  componentDidMount() {
    self = this;
  }

  static showLoader() {
    try {
      self.setState({ busyIcon: true });
    } catch (e) {}
  }

  static hideLoader() {
    self.setState({ busyIcon: false });
  }

  render() {
    return (
      <div
        className="overlay"
        style={{
          background: "rgb(226 233 233 / 40%)",
          justifyContent: "center",
          position: "fixed",
          width: "100%",
          height: window.innerHeight - 10,
          zIndex: 9999,
          display: this.state.busyIcon ? "flex" : "none",
          alignItems: "center",
        }}>
        <CircularProgress
          style={{ color: this.state.color, width: this.state.width, height: this.state.height }}
        />
      </div>
    );
  }
}
